import React from 'react';
import './Apply.css';
import './Detail.css';
import Header from '../components/header';
import largeImage_mobile from '../images/S__57745422_0.jpg';
import SUbTitle from '../images/Lost_concerts_again.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faTwitter, faYoutube, faLine } from '@fortawesome/free-brands-svg-icons';
import { isMobile } from 'react-device-detect'; // デバイスタイプの検出

const DetailPC = () => {
  return (
    <div>
        <Header />
        <div className="mt-28 bg-black w-full p-0"> {/* Background is black, padding removed */}
        <div className="flex flex-wrap max-w-screen-xl mx-auto"> {/* Set max width and center */}
            <div className="w-full md:w-3/5 flex-shrink-0 mt-10"> {/* Image positioned slightly lower */}
            <img 
                src={SUbTitle} 
                alt="Image 2" 
                className="w-full h-auto object-cover slide-in" /* Image scales with screen width and slides in */
            />
            </div>
            <div className="w-full md:w-1/3 p-4 flex items-center"> {/* Text fixed to the right of the image */}
            <h1 className="text-white font-bold text-lg leading-8">
                <br />失った演奏会の再演を。
                <br />技術も経験も必要ない<br />演奏会を取り戻したい思いだけが、<br />本演奏会への参加資格です<br></br>
                あの演奏会、音楽、つながりを
                <br></br>取り戻したい思いから、
                始動しました。<br /><br />
                見る人も奏でる人も心動かされる演奏会が、<br />
                ここにあります。
            </h1>
            </div>
        </div>
        </div>
        <div className="mt-12 bg-white w-full p-4 mx-auto max-w-4xl"> {/* 背景を白にし、幅を広くし中央に寄せる */}
            <div className="text-black mt-4">
            <p className="border-b border-gray-500 pb-2 font-bold text-blue-300 text-base"> {/* Font size further reduced */}
                    演奏会名称 / 主催
                </p>
                <p className="pb-2">
                    
                    「あの演奏会をもう一度、」2025<br />
                </p>
                <br /><br />
                <p className="border-b border-gray-500 pb-2 font-bold text-blue-300 text-base"> {/* Font size further reduced */}
                    開催日時 / 場所
                </p>
                <p className="pb-2">
                    2025年9月14日（日）/<br />
                    <a href="https://abeno-cc.net/guidance/room_details/hall02" className="text-blue-500 underline hover:text-blue-700">大阪市阿倍野区民センター小ホール</a>
                </p>
                <br /><br />
                <p className="border-b border-gray-500 pb-2 font-bold text-blue-300 text-base"> {/* Font size further reduced */}
                    曲目
                </p>
                <p className="pb-2">
                第1部<br />魂の還る場所 / 丸本 大悟<br />遥かなる旅路へ / 末廣 健児<br /><br />
                第2部<br />彗星のタイムカプセル/ 青山 涼<br />コバルトブルーの奇跡 / 武藤理恵<br />
                <br />※1曲だけの参加でも大歓迎です！
                </p>
                <br /><br />
                <p className="border-b border-gray-500 pb-2 font-bold text-blue-300 text-base"> {/* Font size further reduced */}
                    参加要件
                </p>
                <p className="pb-2"><br />
                    コロナウイルス拡大により、部活動、演奏会が開催
                    されなかったマンドリンクラブOBの皆様<br /><br />
                    <u>2017年から2022年入学の全国のマンドリンクラブOB（高校、大学どちらでも！）の方を</u><u>中心に集めております。</u><br />お住いの地域、出身地、大学も関係ございません！<br /><br />
                    ※上記の代を中心に集めますが、その他の方もご連絡お待ちしております。
                </p>
                <br />
                <p className="border-b border-gray-500 pb-2 font-bold text-blue-300 text-base"> {/* Font size further reduced */}
                    演奏会・練習雰囲気
                </p>
                <p className="pb-2"><br />
                    マンドリンクラブから離れた方でも大歓迎ですので、
                    技術面でのご心配は不要です！！<br />
                    コロナにより行われなかった演奏会と交流などを、
                    取り戻すことを目的として開催をおります。
                    <br /><br />
                    練習のみの参加や本番のみの参加、または一部の時間だけの参加も大丈夫です。<br /><br />
                    ご質問がある場合は、参加フォームや各種SNSからお気軽にお問い合わせください。<br />
                </p>
                <br /><br />
                <p className="border-b border-gray-500 pb-2 font-bold text-blue-300 text-base"> {/* Font size further reduced */}
                    練習について
                </p>
                <p className="pb-2">
                    <br />  ・楽器＝ご自身での準備（レンタルの方がほとんどです！）<br />  ・場所＝基本大阪府内の施設（人数により関東開催も）
                    <br />  ・練習頻度=月1回程度<br />  ・演奏会参加費用=5,000~10,000円程度（練習参加費用500~1,000円）
                </p>
                <br /><br />
                <p className="border-b border-gray-500 pb-2 font-bold text-blue-300 text-base"> {/* Font size further reduced */}
                    協力
                </p>
                <p className="pb-2">
                    {/* 紀の国マンドリンオーケストラ<br /> */}
                </p>
            </div>
        </div>
        <br></br><br></br><br></br>
        <div className="flex justify-center mt-6">
            <a href="https://www.instagram.com/anoen2025/?utm_source=ig_embed&ig_rid=e42f20b4-19c3-432a-93bd-d224e592bd6b" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white mx-7">
                <FontAwesomeIcon icon={faInstagram} size="2x" />
            </a>
            <a href="https://x.com/anoen2025?ref_src=twsrc%5Etfw%7Ctwcamp%5Eembeddedtimeline%7Ctwterm%5Escreen-name%3Aanoen2025%7Ctwcon%5Es1" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white mx-7">
                <FontAwesomeIcon icon={faTwitter} size="2x" />
            </a>
            <a href="https://www.youtube.com/@%E3%81%82%E3%81%AE%E6%BC%94" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white mx-7">
                <FontAwesomeIcon icon={faYoutube} size="2x" />
            </a>
        </div>
        <div className="text-center mt-10">
            <p className="text-black-400">Copyright © 2024 「あの演奏会をもう一度」運営 <br></br>All Rights Reserved.</p>
        </div>
        <br></br>
        <br></br>
    </div>
  );
}

const DetailMobile = () => {
    return (
      <div>
          <Header />

          <div className="mt-16 bg-black w-full p-0"> {/* Background is black, padding removed */}
            <div className="flex flex-wrap max-w-screen-xl mx-auto"> {/* Set max width and center */}
                <div className="w-full md:w-3/5 flex-shrink-0 mt-10"> {/* Image positioned slightly lower */}
                <img 
                    src={SUbTitle} 
                    alt="Image 2" 
                    className="w-full h-auto object-cover slide-in" /* Image scales with screen width and slides in */
                />
                </div>
                <div className="w-full md:w-1/3 p-4 flex items-center"> {/* Text fixed to the right of the image */}
                <h1 className="text-white font-bold text-xs leading-6"> {/* Font size further reduced */}
                    <br />失った演奏会の再演を。
                    <br />技術も経験も必要ない<br />演奏会を取り戻したい思いだけが、<br />本演奏会への参加資格です<br></br>
                    あの演奏会、音楽、つながりを
                    <br></br>取り戻したい思いから、
                    始動しました。<br /><br />
                    見る人も奏でる人も<br></br>心動かされる演奏会が、<br />
                    ここにあります。
                </h1>
                </div>
            </div>

            {/* Large Image below the h1 with some horizontal margin */}
            <div className="w-full p-8 flex justify-center mt-8"> {/* Add some padding and top margin */}
                <img 
                src={largeImage_mobile} 
                alt="Mobile Image" 
                className="w-full h-auto md:w-2/3 object-cover" /* Scale the image with some width adjustment for medium screens */
                />
            </div>
            </div>
          <div className="mt-12 bg-white w-full p-4 mx-auto max-w-4xl"> {/* 背景を白にし、幅を広くし中央に寄せる */}
            <div className="text-black mt-4 text-xs"> {/* Font size further reduced */}
                <p className="border-b border-gray-500 pb-2 font-bold text-blue-300 text-base"> {/* Font size further reduced */}
                    演奏会名称 / 主催
                </p>
                <p className="pb-2">
                    
                    「あの演奏会をもう一度、」<br />
                </p>
                <br /><br />
                <p className="border-b border-gray-500 pb-2 font-bold text-blue-300 text-base"> {/* Font size further reduced */}
                    開催日時
                </p>
                <p className="pb-2">
                    2025年9月14日（日）<br />
                </p>
                <br /><br />
                <p className="border-b border-gray-500 pb-2 font-bold text-blue-300 text-base"> {/* Font size further reduced */}
                    場所
                </p>
                <p className="pb-2">
                    <a href="https://abeno-cc.net/guidance/room_details/hall02" className="text-blue-500 underline hover:text-blue-700">大阪市阿倍野区民センター小ホール</a>
                </p>
                <br /><br />
                <p className="border-b border-gray-500 pb-2 font-bold text-blue-300 text-base"> {/* Font size further reduced */}
                    曲目
                </p>
                <p className="pb-2">
                第1部<br />魂の還る場所 / 丸本 大悟<br />遥かなる旅路へ / 末廣 健児<br /><br />
                第2部<br />彗星のタイムカプセル/ 青山 涼<br />コバルトブルーの奇跡 / 武藤理恵<br />
                <br /><font color="#FF0000">※1曲だけの参加でも大歓迎です！</font>
                </p>
                <br /><br />
                <p className="border-b border-gray-500 pb-2 font-bold text-blue-300 text-base"> {/* Font size further reduced */}
                    参加要件
                </p>
                <p className="pb-2">
                    コロナウイルス拡大により、<br />
                    部活動、演奏会が開催
                    されなかったマンドリンクラブOBの皆様<br /><br />
                    <u>2017年から2022年入学の<br /><font color="#FF0000">全国のマンドリンクラブOB(高校、大学どちらでも！)</font><br />の方を</u><u>中心に集めております。</u><br />お住いの地域、出身地、大学も関係ございません！<br /><br />
                    
                    ※上記の代を中心に集めますが、<br />その他の方もご連絡お待ちしております。
                </p>
                <br /><br />
                <p className="border-b border-gray-500 pb-2 font-bold text-blue-300 text-base"> {/* Font size further reduced */}
                    演奏会・練習雰囲気
                </p>
                <p className="pb-2">
                    マンドリンクラブから離れた方でも大歓迎ですので、<br />
                    技術面でのご心配は不要です！！<br /><br />
                    コロナにより行われなかった演奏会と交流などを、<br />
                    取り戻すことを目的として開催をおります。
                    <br /><br />
                    そのため、<font color="#FF0000">練習のみの参加や本番のみの参加</font>、<br />または<font color="#FF0000">一部の時間だけの参加</font>も大丈夫です。<br /><br />
                    ご質問がある場合は、<br />参加フォームや各種SNSからお気軽にお問い合わせください。<br />
                </p>
                <br /><br />
                <p className="border-b border-gray-500 pb-2 font-bold text-blue-300 text-base"> {/* Font size further reduced */}
                    練習について
                </p>
                <p className="pb-2">
                    <br />  ・楽器＝ご自身での準備（レンタルの方がほとんどです！）<br />  ・場所＝基本大阪府内の施設（人数により関東開催も）
                    <br />  ・練習頻度=月1回程度<br />  ・演奏会参加費用=5,000~10,000円程度（練習参加費用500~1,000円）
                </p>
                <br /><br />
                <p className="border-b border-gray-500 pb-2 font-bold text-blue-300 text-base"> {/* Font size further reduced */}
                    協力
                </p>
                <p className="pb-2">
                    {/* 紀の国マンドリンオーケストラ<br /> */}
                </p>
            </div>
        </div>
          <br></br><br></br><br></br>
          <div className="flex justify-center mt-6">
            <a href="https://www.instagram.com/anoen2025/?utm_source=ig_embed&ig_rid=e42f20b4-19c3-432a-93bd-d224e592bd6b" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white mx-7">
                <FontAwesomeIcon icon={faInstagram} size="2x" />
            </a>
            <a href="https://x.com/anoen2025?ref_src=twsrc%5Etfw%7Ctwcamp%5Eembeddedtimeline%7Ctwterm%5Escreen-name%3Aanoen2025%7Ctwcon%5Es1" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white mx-7">
                <FontAwesomeIcon icon={faTwitter} size="2x" />
            </a>
            <a href="https://www.youtube.com/@%E3%81%82%E3%81%AE%E6%BC%94" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white mx-7">
                <FontAwesomeIcon icon={faYoutube} size="2x" />
            </a>
          </div>
          <div className="text-center mt-10">
              <p className="text-black-400">Copyright © 2024 「あの演奏会をもう一度」運営 <br></br>All Rights Reserved.</p>
          </div>
          <br></br>
          <br></br>
      </div>
    );
  }


  function Detail() {
    return isMobile ? <DetailMobile /> : <DetailPC />;
  }

export default Detail;
